import {
  Logger,
  toResponseError,
  type EntityId,
  type Preference,
  type Preferences,
  type PreferenceUpdateInput,
  type PreferenceUpdateSuccess,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { usePreferenceCache } from './cache'

const logger = new Logger('useUpdatePreference')

export function useUpdatePreference<T extends Preference>(
  preference: T,
  targetId?: EntityId
): UpdateHookResponse<Preferences[T]> {
  const { clearItem } = usePreferenceCache()
  const mutation = useTantalimMutation<PreferenceUpdateInput<T>, PreferenceUpdateSuccess<T>>({
    url: '/preference/update',
  })

  async function update(value: Preferences[T]): Promise<Preferences[T]> {
    try {
      // Send the explicit null clear the API prefers; `undefined` means reset here.
      const output = await mutation.mutateAsync({ preference, value: value ?? null, targetId })
      clearItem(preference, targetId)
      logger.info('update succeeded', preference, output.value)
      return output.value
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
